import Vue from 'vue' 
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import 'core-js'


$("document").ready(function() {


  

  
  if ($('.hamburger').length > 0) {
    $('.hamburger').bind('click',function() { 
      
      $(this).toggleClass('is-active');
      $('.mobileMenu').toggleClass('active');
    
      return false;
    });

 
    
  }


  if ($('.gallery').length > 0) {
 
    $('a.gallery').featherlightGallery({
      previousIcon: '&#9664;',     
      nextIcon: '&#9654;',         
      galleryFadeIn: 100,          
      galleryFadeOut: 300          
    });
  }

  if ($('.masonry').length > 0) {

    $('.masonry').masonry({ 
      columnWidth: ".grid-sizer",
      itemSelector: ".element",
      gutter:30 });
  }
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
        $('html, body').animate({
        scrollTop: target.offset().top-100
        }, 1000);
        return false;
    }
    }
});

});